var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#5AA58C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.218 17.79v-2.716h6.157V11h-16.75v4.074h6.157v2.716C12.802 18.06 9 19.057 9 20.234s3.803 2.173 8.782 2.445v8.6h4.436v-8.6c4.98-.272 8.782-1.177 8.782-2.445 0-1.267-3.802-2.173-8.782-2.444Zm0 4.074h-2.173c-1.177 0-1.992 0-2.263-.09-4.436-.091-7.696-.815-7.696-1.811s3.26-1.72 7.696-1.902v2.988c.271 0 1.086.09 2.263.09 1.358 0 2.083-.09 2.173-.09v-2.897c4.436.181 7.696.996 7.696 1.901 0 .906-3.26 1.63-7.696 1.811Z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.becc0e02.svg";
export { ForwardRef as ReactComponent };